import { _t } from '../base.js'

function moveBottomMenu() {
    const footerArticles = document.querySelector('.custom-footer__articles')
    const navigationWrapper = document.querySelector('.container.navigation-wrapper')

    if (footerArticles && navigationWrapper) {
        navigationWrapper.parentNode.insertBefore(footerArticles, navigationWrapper.nextSibling)
    }
}

function moveHeaderContacts() {
    const phone = document.querySelector('.kn_phone')
    const mail = document.querySelector('.kn_mail')
    const logo = document.querySelector('.site-name')

    if (phone && mail && logo) {
        const newWrapper = document.createElement('div')
        newWrapper.className = 'header-contacts'

        const mailClone = mail.cloneNode(true)
        const phoneClone = phone.cloneNode(true)

        newWrapper.appendChild(mailClone)
        newWrapper.appendChild(phoneClone)

        logo.parentNode.insertBefore(newWrapper, logo)
    }
}

function addMobileNavTitles() {
    const menu = document.querySelector('.menu-level-1')

    if (menu) {
        const firstItem = menu.querySelector('.menu-item-741')
        if (firstItem) {
            const headingOthers = document.createElement('h2')
            headingOthers.textContent = _t('header.others')
            menu.insertBefore(headingOthers, firstItem)
        }

        const firstCategory = menu.querySelector('.appended-category')
        if (firstCategory) {
            const headingCategories = document.createElement('h2')
            headingCategories.textContent = _t('header.categories')
            menu.insertBefore(headingCategories, firstCategory)
        }

        const socialMenu = menu.querySelector('.soc_mobile')
        if (socialMenu) {
            const headingFollowUs = document.createElement('h2')
            headingFollowUs.textContent = _t('header.followUs')
            menu.insertBefore(headingFollowUs, socialMenu)
        }
    }
}

function createSubmenuCarousel() {
    const footerArticles = document.querySelector('.custom-footer__articles ul')

    if (footerArticles) {
        const swiperContainer = document.createElement('div')
        swiperContainer.classList.add('swiper')

        const swiperWrapper = document.createElement('ul')
        swiperWrapper.classList.add('swiper-wrapper')

        Array.from(footerArticles.children).forEach((li) => {
            li.classList.add('swiper-slide')
            swiperWrapper.appendChild(li)
        })

        swiperContainer.appendChild(swiperWrapper)
        footerArticles.parentNode.replaceChild(swiperContainer, footerArticles)

        new Swiper('.custom-footer__articles .swiper', {
            slidesPerView: 'auto',
            spaceBetween: 30,
            freeMode: true,
            centeredSlides: false,
            breakpoints: {
                768: {
                    spaceBetween: 50,
                },
            },
        })
    }
}

function redirectCartBtnToCartPage() {
    $('.navigation-buttons .cart-count').removeClass('toggle-window')
}

export function initHeader() {
    moveHeaderContacts()
    moveBottomMenu()
    addMobileNavTitles()
    createSubmenuCarousel()
    redirectCartBtnToCartPage()
}
